import {useIsPermitted} from 'common/hooks/useIsPermitted';
import {useFieldValue} from 'components/hook-form/useFieldValue';
import {DiplomatObjectAceType} from 'types/diplomat/settings/permissions/DiplomatObjectAceType';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';

export const useIsTestPermitted = () => {
   const id = useFieldValue<IDiplomatObject>('id') as string;
   const objectType = useFieldValue<IDiplomatObject>('objectType') as DiplomatObjectTypeUnion;

   const isPermitted = useIsPermitted(objectType, id);

   return (
      objectType == 'EMAIL_SERVER_SETTINGS' ||
      isPermitted(DiplomatObjectAceType.enum.EXECUTE) ||
      isPermitted(DiplomatObjectAceType.enum.MODIFY)
   );
};
